export class AgrirouterEndpoint {
  id: string;
  name: string;

  constructor(id: string, name: string) {
    this.id = id;
    this.name = name;
  }

  static fromFADEItem(fadeEndpointItem): AgrirouterEndpoint {
    return new AgrirouterEndpoint(fadeEndpointItem.endpointID, fadeEndpointItem.endpointName);
  }
}
